import { useState } from 'react';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import SplashScreen from './components/SplashScreen';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services'; 
import CollectionProducts from './components/CollectionProducts';
import Sustainability from './components/Sustainability';
import PrivateClient from './components/PrivateClient';
// import Hospitality from './components/Hospitality';
// import Journal from './components/Journal';
import Contact from './components/Contact';
import OurProcess from './components/OurProcess';
import Concept1 from './components/Concept1';
import Concept2 from './components/Concept2';

import './App.css';

function App() {
  const [showSplash, setShowSplash] = useState(() => {
    return sessionStorage.getItem('splashShown') !== 'true';
  });
  const [fadeOut, setFadeOut] = useState(false);

  const handleNavigateHome = () => {
    setFadeOut(true);
    
    setTimeout(() => {
      setShowSplash(false);
      sessionStorage.setItem('splashShown', 'true');
    }, 800);
  };

  if (showSplash) {
    return <SplashScreen onNavigate={handleNavigateHome} fadeOut={fadeOut} />;
  }

  return (
    <div className="app-content">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/process" element={<OurProcess/>} />
        <Route path="/services" element={<Services/>} />
        <Route path="/collections" element={<CollectionProducts/>} />
        <Route path="/sustainability" element={<Sustainability/>} />
        <Route path="/private-client" element={<PrivateClient/>} />
        {/* <Route path="/hospitality" element={<Hospitality/>} />
        <Route path="/journal" element={<Journal/>} /> */}
        <Route path="/contact" element={<Contact/>} />
         <Route path="/concept" element={<Concept1/>} />
          <Route path="/concept-2" element={<Concept2/>} />
      </Routes>
    </div>
  );
}

export default App;